module.exports = __webpack_public_path__ + "img/een-logo.b6a0a797.png";